import { DIGITAL_PROGRAMS } from 'app/crud/activityGenerationIndex.crud';
import axios from 'axios';

export function getInvitedPrograms(params, signal) {
  return axios.get(`${DIGITAL_PROGRAMS}/mine`, { params, signal });
}

export function getInvitedContentPrograms(contentGuid, signal) {
  return axios.get(`${DIGITAL_PROGRAMS}/mine/contents/${encodeURIComponent(contentGuid)}`, { signal });
}
